import React from "react";
import { useTranslation } from "react-i18next";

import style from "components/reports/notification-details/notification-details.scss";

import testIds from "testIds.json";

interface Props {
    groupName?: string;
    totalRequestedAssets?: number;
    totalSucceededAssets?: number;
    totalFailedAssets?: number;
}

const AssetJobSummary = (props: Props) => {
    const { t } = useTranslation();
    const rows = [
        {
            label: t("Notification.assetJobSummary.groupName"),
            value: props.groupName,
            testId: testIds.workArea.asset.assetJobSummary.groupName,
        },
        {
            label: t("Notification.assetJobSummary.requestedAssets"),
            value: props.totalRequestedAssets,
            testId: testIds.workArea.asset.assetJobSummary.requestedAssets,
        },
        {
            label: t("Notification.assetJobSummary.succeededAssets"),
            value: props.totalSucceededAssets,
            testId: testIds.workArea.asset.assetJobSummary.succeededAssets,
        },
        {
            label: t("Notification.assetJobSummary.failedAssets"),
            value: props.totalFailedAssets,
            testId: testIds.workArea.asset.assetJobSummary.failedAssets,
        },
    ].filter((row) => row.value !== undefined);

    if (rows.length === 0) {
        return null;
    }

    return (
        <div className={style.details} data-testid={testIds.workArea.asset.assetJobSummary.itself}>
            {rows.map((row) => (
                <div key={row.testId} data-testid={row.testId}>
                    <strong>{row.label}</strong> {row.value}
                </div>
            ))}
        </div>
    );
};

export default AssetJobSummary;
